/**
 * EloBadge — backward compatibility wrapper.
 * All logic and rendering now lives in CrownFrameBadge.
 * This file re-exports everything so existing imports continue to work.
 */
import CrownFrameBadge, {
  RANK_TIERS,
  CARD_RANKS,
  SUIT_LEVELS,
  getRankFromPoints,
  getRankProgress,
} from './CrownFrameBadge';

export { RANK_TIERS, CARD_RANKS, SUIT_LEVELS, getRankFromPoints, getRankProgress };
export default CrownFrameBadge;
